export default "<section class=\"full\">\r\n    <router-outlet></router-outlet>\r\n</section>\r\n"